<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      docmWidth: '',
      showWidth: ''
    }
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        let width = document.documentElement.clientWidth
        document.querySelector('body').style.width = `${width}px`
      })()
    }
  }
}
</script>

<style>
@import url('./assets/css/reset');
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue